import {
  DragIndicator,
  Notifications as NotificationsIcon,
} from '@mui/icons-material';
import { TabContext } from '@mui/lab';
import { Box, Divider, Tooltip } from '@mui/material';

import InfoIcon from '../../assets/images/info-icon.svg';
import { NotificationBtn, TitleBox } from '../../components/UI/Box';
import { IconAdminPanelSettingsMS } from '../../constants/icons';
import { Constants } from '../../constants/oversight';
import { StyledTabList, TabStyled } from '../Hive/styles';
import { StyledTabPanel } from '../UserManagement/styles';
import { Notifications } from './components/Notifications';
import { GridMainContainer, NotificationBadge, Title } from './styles';
import { AdministrativeUsers } from './Tabs/AdministrativeUsers';
import { OversightClients } from './Tabs/Clients';
import {
  ContainerGroup,
  Panel,
  StyledSeparator,
} from './Tabs/Clients/CustomerDetails/styles';
import useOversight from './useOversight';

export function Oversight(): JSX.Element {
  const {
    oversightUserRole,
    currentTab,
    handleChangeTab,
    openNotifications,
    handleOpenNotifications,
    handleCloseNotifications,
    defaultLayout,
    onLayoutChanged,
    unreadCount,
    handleNotificationRead,
  } = useOversight();

  const canSeeAdministrativeUsers =
    oversightUserRole === 'auditor' || oversightUserRole === 'admin';

  return (
    <ContainerGroup
      orientation="horizontal"
      defaultLayout={defaultLayout}
      onLayoutChanged={onLayoutChanged}
    >
      <Panel id="left" minSize="50%">
        <GridMainContainer>
          <TitleBox>
            <Title>
              {IconAdminPanelSettingsMS}
              {Constants.oversight}
              <Tooltip
                describeChild
                title={Constants.oversight_title_tooltip}
                slotProps={{
                  tooltip: {
                    sx: {
                      whiteSpace: 'nowrap',
                      maxWidth: 'none',
                    },
                  },
                }}
              >
                <img src={InfoIcon} alt="Ícone de informação" />
              </Tooltip>
            </Title>
            <NotificationBtn
              aria-label={Constants.notifications_open}
              onClick={handleOpenNotifications}
            >
              <NotificationBadge variant="dot" invisible={unreadCount === 0}>
                <NotificationsIcon />
              </NotificationBadge>
            </NotificationBtn>
          </TitleBox>
          <Box>
            <TabContext value={currentTab}>
              <StyledTabList
                onChange={(_, newValue) => handleChangeTab(newValue)}
              >
                <TabStyled label="Clientes" value="clients" />
                {canSeeAdministrativeUsers && (
                  <TabStyled
                    label="Usuários Administrativos"
                    value="administrative-users"
                  />
                )}
              </StyledTabList>
              <StyledTabPanel value="clients">
                <OversightClients />
              </StyledTabPanel>
              {canSeeAdministrativeUsers && (
                <>
                  <Divider />
                  <StyledTabPanel value="administrative-users">
                    <AdministrativeUsers />
                  </StyledTabPanel>
                </>
              )}
            </TabContext>
          </Box>
        </GridMainContainer>
      </Panel>
      <StyledSeparator className="resize-handle">
        <DragIndicator fontSize="small" />
      </StyledSeparator>
      {openNotifications && (
        <Panel id="right">
          <Notifications
            unreadCount={unreadCount}
            onClose={handleCloseNotifications}
            onRead={handleNotificationRead}
          />
        </Panel>
      )}
    </ContainerGroup>
  );
}
